import { motion } from "framer-motion";

const links = [
  { label: "SHOWREEL", href: "#showreel", testId: "nav-link-showreel" },
  { label: "SERVICES", href: "#services", testId: "nav-link-services" },
  { label: "CREDITS", href: "#credits", testId: "nav-link-credits" },
  { label: "CONTACT", href: "#contact", testId: "nav-link-contact" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1, delay: 0.2, ease: [0.16, 1, 0.3, 1] }}
      className="fixed top-0 z-40 w-full mix-blend-difference"
    >
      <nav className="flex items-center justify-between px-6 py-6 md:px-10">
        <a href="#top" data-testid="nav-logo" aria-label="Bite — back to top">
          <img
            src="/assets/bite-mark.png"
            alt="Bite B mark — AI advertising and production studio"
            className="h-7 w-auto"
          />
        </a>
        <div className="flex items-center gap-6 font-mono text-[10px] tracking-[0.3em] text-white md:gap-10">
          {links.map((link) => (
            <a
              key={link.href}
              href={link.href}
              data-testid={link.testId}
              className="hidden transition-colors duration-300 hover:text-[#E1A730] sm:block"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#contact"
            data-testid="nav-cta-contact"
            className="rounded-full border border-white/40 px-4 py-2 transition-colors duration-300 hover:border-[#E1A730] hover:bg-[#E1A730] hover:text-black"
          >
            START A PROJECT
          </a>
        </div>
      </nav>
    </motion.header>
  );
}
